// extracted by mini-css-extract-plugin
export var borderRadius = "_5h-4";
export var large = "_5h-3";
export var logoContainer = "_5h-0";
export var nameLogo = "_5h-2";
export var small = "_5h-1";